import mutations from './appointmentInpatientModal.mutations'
import actions from './appointmentInpatientModal.actions'
import getters from './appointmentInpatientModal.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
